import { useIntl } from '@umijs/max';
import { message } from 'antd';
import { useMemo } from 'react';
import { ErrorType, useError } from './useError';

export const useMessage = () => {
  const intl = useIntl();
  const errors: Record<ErrorType | string, (params?: any) => string> =
    useError();

  return useMemo(() => {
    const adding = () =>
      message.loading(
        intl.formatMessage({
          id: 'common.message.adding',
          defaultMessage: 'Đang thêm dữ liệu...',
        }),
      );

    const addSuccess = () =>
      message.success(
        intl.formatMessage({
          id: 'common.message.addSuccess',
          defaultMessage: 'Thêm dữ liệu thành công',
        }),
      );

    const addError = (error?: any) =>
      message.error(
        errors[error.data?.message ?? error.data?.error]?.() ??
          intl.formatMessage(
            {
              id: 'common.message.addError',
              defaultMessage: 'Thêm dữ liệu thất bại. Mã lỗi: {error}',
            },
            {
              error: error.data?.message ?? error.data?.error,
            },
          ),
      );

    const updating = () =>
      message.loading(
        intl.formatMessage({
          id: 'common.message.updating',
          defaultMessage: 'Đang cập nhật dữ liệu...',
        }),
      );

    const updateSuccess = () =>
      message.success(
        intl.formatMessage({
          id: 'common.message.updateSuccess',
          defaultMessage: 'Cập nhật dữ liệu thành công',
        }),
      );

    const updateError = (error?: any) =>
      message.error(
        errors[error.data?.message ?? error.data?.error]?.() ??
          intl.formatMessage(
            {
              id: 'common.message.updateError',
              defaultMessage: 'Cập nhật dữ liệu thất bại. Mã lỗi: {error}',
            },
            {
              error: error.data?.message ?? error.data?.error,
            },
          ),
      );

    const deleting = () =>
      message.loading(
        intl.formatMessage({
          id: 'common.message.deleting',
          defaultMessage: 'Đang xóa dữ liệu...',
        }),
      );

    const deleteSuccess = () =>
      message.success(
        intl.formatMessage({
          id: 'common.message.deleteSuccess',
          defaultMessage: 'Xóa dữ liệu thành công',
        }),
      );

    const deleteError = (error?: any) =>
      message.error(
        errors[error.data?.message ?? error.data?.error]?.() ??
          intl.formatMessage(
            {
              id: 'common.message.deleteError',
              defaultMessage: 'Xóa dữ liệu thất bại. Mã lỗi: {error}',
            },
            {
              error: error.data?.message ?? error.data?.error,
            },
          ),
      );

    const uploading = () =>
      message.loading(
        intl.formatMessage({
          id: 'common.message.uploading',
          defaultMessage: 'Đang tải tập tin lên...',
        }),
      );

    const uploadSuccess = () =>
      message.success(
        intl.formatMessage({
          id: 'common.message.uploadSuccess',
          defaultMessage: 'Tải tập tin lên thành công',
        }),
      );

    const uploadError = (error?: any) =>
      message.error(
        errors[error.data?.message ?? error.data?.error]?.() ??
          intl.formatMessage(
            {
              id: 'common.message.uploadError',
              defaultMessage: 'Tải tập tin lên thất bại. Mã lỗi: {error}',
            },
            {
              error: error.data?.message ?? error.data?.error,
            },
          ),
      );

    return {
      ...message,
      adding,
      addSuccess,
      addError,
      updating,
      updateSuccess,
      updateError,
      deleting,
      deleteSuccess,
      deleteError,
      uploading,
      uploadSuccess,
      uploadError,
    };
  }, [intl.locale]);
};
